//
//
//
//
//
//
//
//

import FilesInput from './form/FilesInput';

let counter = 0;
let intervals = {};

export default {
    extends: FilesInput,

    props: {
        hasErrorFn: Function,
    },

    computed: {
        files: {
            get() {
                return this.model;
            },
            set(value) {
                this.model = value;
            },
        },
    },

    methods: {
        addFiles(files) {
            this.files.unshift(...files.map(f => {
                const file = {
                    name: f.name,
                    temp: true,
                    percentage: 0,
                };

                intervals[counter] = setInterval(this.incrementPercentage, 50, file, counter);

                counter += 1;

                return file;
            }));
        },
        incrementPercentage(file, key) {
            file.percentage += Math.random() * 3 + 1;

            if (file.percentage >= 100)  {
                file.percentage = 100;

                clearInterval(intervals[key]);
            }
        },
        nameFn(file) {
            return file.name;
        },
        progressFn(file) {
            return (file.percentage != null && file.percentage < 100) ? file.percentage / 100 : null;
        },
        canDownloadFn(file) {
            return !file.temp;
        },
        downloadFn(file) {
            console.log("Download:", file.name);
        },
        removeFn(file) {
            const idx = this.files.indexOf(file);

            if (idx !== -1) {
                this.files.splice(idx, 1);
            }
        },
        onDrop(data) {
            if (data.files.length) {
                this.addFiles([...data.files]);
            }
        },
    },
};
